import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { WhitelabelService } from 'src/app/core/services/whitelabel.service';

@Component({
  selector: 'app-activity-log',
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.css']
})
export class ActivityLogComponent implements OnInit {

  logo: string = '../../../../assets/img/logo1.svg';

  @Input() activeLogList: [];

  @ViewChild('dialogActivityLog') public dialogAddCustomer: TemplateRef<any>;
  private dialogActivityLog: NgbModalRef;

  constructor(
    private modalService: NgbModal,
    private whitelabelService: WhitelabelService
  ) { }

  ngOnInit(): void {
    this.whitelabelService.logo.subscribe((logo) => {
      if (logo) this.logo = logo;
    });
  }

  open(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.dialogActivityLog = this.modalService.open(this.dialogAddCustomer)
      this.dialogActivityLog.result.then(resolve, resolve)
    })
  }

  async close(): Promise<void> {
    this.dialogActivityLog.close()
  }


}
